import React, { useState } from 'react'
import i18n from 'i18next'
import Icon from '@components/icon/Icon'
import DataSources from '@components/imagemap/left-panel/data-source'
import SlidePanel from '@/components/imagemap/left-panel/slide'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import './editor-left-panel.less'

const EditorLeftPanel = () => {
  const [activeTab, setActiveTab] = useState('slides')

  return (
    <TooltipProvider delayDuration={200}>
      <div className="editor-left-panel-shell">
        <div className="editor-left-panel" id="editor-left-panel">
          <Tabs
            className="editor-left-panel-tabs"
            orientation="vertical"
            value={activeTab}
            onValueChange={setActiveTab}
          >
            <TabsList aria-label={i18n.t('editor.left-panel.panels')}>
              <span
                className={`indico-tabs-indicator ${
                  activeTab === 'data-sources' ? 'indico-tabs-indicator-second' : ''
                }`}
                aria-hidden="true"
              />
              <Tooltip>
                <TooltipTrigger asChild>
                  <span className="editor-left-panel-tab-anchor">
                    <TabsTrigger
                      value="slides"
                      aria-label={i18n.t('editor.left-panel.slides.title')}
                    >
                      <Icon name="clone" prefix="far" size={0.85} />
                    </TabsTrigger>
                  </span>
                </TooltipTrigger>
                <TooltipContent side="right">
                  {i18n.t('editor.left-panel.slides.title')}
                </TooltipContent>
              </Tooltip>
              <Tooltip>
                <TooltipTrigger asChild>
                  <span className="editor-left-panel-tab-anchor">
                    <TabsTrigger
                      value="data-sources"
                      aria-label={i18n.t('editor.left-panel.data-sources.title')}
                    >
                      <Icon name="database" size={0.85} />
                    </TabsTrigger>
                  </span>
                </TooltipTrigger>
                <TooltipContent side="right">
                  {i18n.t('editor.left-panel.data-sources.title')}
                </TooltipContent>
              </Tooltip>
            </TabsList>
            <TabsContent value="slides">
              <SlidePanel />
            </TabsContent>
            <TabsContent value="data-sources">
              <DataSources />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </TooltipProvider>
  )
}

export default React.memo(EditorLeftPanel)
